export default "__VITE_ASSET__BY7kS8xf__"